// Profile validation utilities

export const validatePhone = (phone) => {
  if (!phone) return true // Optional field
  // Remove formatting and check if it's a valid Brazilian phone number
  const cleaned = phone.replace(/\D/g, '')
  return cleaned.length >= 10 && cleaned.length <= 11
}

export const validateSocialUrl = (url, platform) => {
  if (!url) return true // Optional field
  
  // If it doesn't contain http, assume it's a username/handle
  if (!url.includes('http')) return true
  
  try {
    const urlObj = new URL(url)
    const hostname = urlObj.hostname.toLowerCase()
    
    switch (platform) {
      case 'facebook':
        return hostname.includes('facebook.com') || hostname.includes('fb.com')
      case 'instagram':
        return hostname.includes('instagram.com')
      case 'linkedin':
        return hostname.includes('linkedin.com')
      default:
        return true
    }
  } catch {
    return false
  }
}

export const getValidationErrors = (values) => {
  const errors = {}
  
  if (values.phone && !validatePhone(values.phone)) {
    errors.phone = 'Número de telefone inválido'
  }
  
  if (values.cellphone && !validatePhone(values.cellphone)) {
    errors.cellphone = 'Número de celular inválido'
  }
  
  if (values.facebookProfile && !validateSocialUrl(values.facebookProfile, 'facebook')) {
    errors.facebookProfile = 'URL do Facebook inválida'
  }
  
  if (values.instagramProfile && !validateSocialUrl(values.instagramProfile, 'instagram')) {
    errors.instagramProfile = 'URL do Instagram inválida'
  }
  
  if (values.linkedinProfile && !validateSocialUrl(values.linkedinProfile, 'linkedin')) {
    errors.linkedinProfile = 'URL do LinkedIn inválida'
  }
  
  return errors
}